<template>
  <div id="app">
    <router-view  :key="$route.fullPath"/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
 @import './utils/comm.css';
</style>



// WEBPACK FOOTER //
// src/App.vue